'use strict';

var MarketProductGroupTDChartDowFilterFactory = function MarketProductGroupTDChartDowFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartDowFilter() {
    DemandFilter.call(this, 'market-product-group', 'thematic-demand-chart-any-dow');
    this.registerFilters(injectedFilters);
  }
  TDChartDowFilter.constructor = TDChartDowFilter;
  TDChartDowFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartDowFilter;
};
MarketProductGroupTDChartDowFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupTDChartDowFilterFactory;